import { render, staticRenderFns } from "./StatisticsDetail.vue?vue&type=template&id=2662f626&scoped=true"
import script from "./StatisticsDetail.vue?vue&type=script&lang=js"
export * from "./StatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDetail.vue?vue&type=style&index=0&id=2662f626&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662f626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2662f626')) {
      api.createRecord('2662f626', component.options)
    } else {
      api.reload('2662f626', component.options)
    }
    module.hot.accept("./StatisticsDetail.vue?vue&type=template&id=2662f626&scoped=true", function () {
      api.rerender('2662f626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/task/components/StatisticsDetail.vue"
export default component.exports